import React from "react";
import "./SecondBrainAnimation.css";
import MindrailLogo from "./MindrailLogo";
import { Pin, Sparkles, Mic, BookOpen, Brain } from "lucide-react";

export default function SecondBrainAnimation() {
  return (
    <div className="absolute inset-0 mr-sb overflow-hidden">
      {/* Browser */}
      <div className="mr-sb-browser">
        <div className="mr-sb-chrome">
          <span className="mr-sb-dot" style={{ background: "#F9735B" }} />
          <span className="mr-sb-dot" style={{ background: "#F59E0B" }} />
          <span className="mr-sb-dot" style={{ background: "#22C55E" }} />
          <div className="mr-sb-url">stripe.com/blog/pricing-page-patterns</div>
        </div>
        <div className="mr-sb-page">
          <div className="mr-sb-page-eyebrow">RESEARCH</div>
          <h1 className="mr-sb-page-h1">Pricing page patterns that quietly outperform.</h1>
          <p className="mr-sb-page-p">A close-read of how the best SaaS landing pages help freelance clients say yes.</p>
          <div className="mr-sb-lines">
            <span className="mr-sb-line" style={{ width: "100%" }} />
            <span className="mr-sb-line" style={{ width: "88%" }} />
            <span className="mr-sb-line" style={{ width: "92%" }} />
            <span className="mr-sb-line" style={{ width: "74%" }} />
            <span className="mr-sb-line" style={{ width: "96%" }} />
            <span className="mr-sb-line" style={{ width: "80%" }} />
            <span className="mr-sb-line" style={{ width: "90%" }} />
            <span className="mr-sb-line" style={{ width: "60%" }} />
          </div>
        </div>
      </div>

      {/* Floating thought chips */}
      <span className="mr-sb-chip mr-sb-chip-1">
        <span className="mr-sb-chip-icn mr-sb-chip-icn-purple">
          <BookOpen className="w-2 h-2" strokeWidth={2.5} />
        </span>
        Parked thought
      </span>
      <span className="mr-sb-chip mr-sb-chip-2">
        <span className="mr-sb-chip-icn mr-sb-chip-icn-blue">
          <Sparkles className="w-2 h-2" strokeWidth={2.5} />
        </span>
        Highlight
      </span>
      <span className="mr-sb-chip mr-sb-chip-3">
        <span className="mr-sb-chip-icn mr-sb-chip-icn-coral">
          <Mic className="w-2 h-2" strokeWidth={2.5} />
        </span>
        Voice note
      </span>
      <span className="mr-sb-chip mr-sb-chip-4">
        <span className="mr-sb-chip-icn mr-sb-chip-icn-amber">
          <Brain className="w-2 h-2" strokeWidth={2.5} />
        </span>
        Brain dump
      </span>

      {/* Memory panel */}
      <div className="mr-sb-orb">
        <div className="mr-sb-head">
          <div className="mr-sb-head-brand">
            <MindrailLogo size={14} />
          </div>
          <Pin className="mr-sb-head-pin w-3 h-3" strokeWidth={2} />
        </div>
        <div className="mr-sb-tabs">
          <span className="mr-sb-tab-active">Memory</span>
          <span>Now</span>
          <span>Review</span>
        </div>

        <div className="mr-sb-sec-title">
          <span>Parked thoughts</span>
          <span className="mr-sb-sec-count">12</span>
        </div>

        <div className="mr-sb-list">
          <div className="mr-sb-item mr-sb-item-1">
            <div className="mr-sb-item-row">
              <span className="mr-sb-item-badge mr-sb-item-badge-purple" />
              <span className="mr-sb-item-label mr-sb-item-label-purple">Just now</span>
            </div>
            <p className="mr-sb-item-text">Turn this pricing rail into a template pack.</p>
            <p className="mr-sb-item-src">stripe.com</p>
          </div>
          <div className="mr-sb-item mr-sb-item-2">
            <div className="mr-sb-item-row">
              <span className="mr-sb-item-badge mr-sb-item-badge-blue" />
              <span className="mr-sb-item-label mr-sb-item-label-blue">Highlight</span>
            </div>
            <p className="mr-sb-item-text">"Anchor pricing on outcomes, not deliverables."</p>
            <p className="mr-sb-item-src">stripe.com · pricing patterns</p>
          </div>
          <div className="mr-sb-item mr-sb-item-3">
            <div className="mr-sb-item-row">
              <span className="mr-sb-item-badge mr-sb-item-badge-coral" />
              <span className="mr-sb-item-label mr-sb-item-label-coral">Voice 0:42</span>
            </div>
            <p className="mr-sb-item-text">Idea: case study from onboarding flow.</p>
            <p className="mr-sb-item-src">recorded 6 min ago</p>
          </div>
          <div className="mr-sb-item mr-sb-item-4">
            <div className="mr-sb-item-row">
              <span className="mr-sb-item-badge mr-sb-item-badge-amber" />
              <span className="mr-sb-item-label mr-sb-item-label-amber">Brain dump</span>
            </div>
            <p className="mr-sb-item-text">3 notes today · 2 patterns surfaced</p>
            <p className="mr-sb-item-src">private to you</p>
          </div>
        </div>

        <div className="mr-sb-total">
          Your second brain · <strong>247 thoughts saved</strong>
        </div>
      </div>

      {/* Footer message card */}
      <div className="mr-sb-foot-card">
        <div className="mr-sb-foot-card-orb">
          <MindrailLogo variant="png-mark" size={14} />
        </div>
        <div className="mr-sb-foot-card-body">
          <div className="mr-sb-foot-card-title">Unload the mental tabs without losing them.</div>
          <div className="mr-sb-foot-card-sub">Parked thoughts · brain dump · session recovery · language mirror.</div>
        </div>
      </div>
    </div>
  );
}
